<template>
  <div class="cont">
    <!-- <div class="title" :style="{ backgroundImage: 'url(' + curData.title + ')'}" :class="title_object">
      <div class="title_name" :style="{ backgroundImage: 'url(' + curData.title_text + ')'}" :class="title_name_object"></div>
    </div> -->
    <div class="clear">
      <el-image style="width: 100%; " v-show="curData.src1" :src="curData.src1" fit="contain"></el-image>
    </div>

  </div>
</template>

<script>
export default {
  name: "ContOne",
  data() {
    return {
      fit: "contain" ,
      id : '' ,
      pageData : {
        FP_FS : {
          name : 'FP/FS型' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/title_text.png') ,
          src1 :  require('@/assets/image/variousproducts/brakediscDetail/FP.FS.png') ,
          src2 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img3.png') ,
          src5 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakediscDetail/FP_FS/img9.png') ,
        },
        HD_HS : {
          name : 'HD/HS型' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/title_text.png') ,
          src1 :  require('@/assets/image/variousproducts/brakediscDetail/HD.HS.png') ,
          src2 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img9.png') ,
          src10 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img10.png') ,
          src11 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img11.png') ,
          src12 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img12.png') ,
          src13 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img13.png') ,
        } ,
        HS : {
          name : 'HS' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/title_text.png') ,
          src1 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img1.png') ,
          src2 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img9.png') ,
          src10 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img10.png') ,
          src11 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img11.png') ,
          src12 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img12.png') ,
          src13 : require('@/assets/image/variousproducts/brakediscDetail/HD_HS/img13.png') ,

        } ,
        SD : {
          name : 'SD型' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/SD/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/SD/title_text.png') ,          
          src1 :  require('@/assets/image/variousproducts/brakediscDetail/SD.png') ,
          src2 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img10.png') ,
          src11 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img11.png') ,
          src12 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img12.png') ,
          src13 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img13.png') ,
          src14 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img14.png') ,
          src15 :  require('@/assets/image/variousproducts/brakediscDetail/SD/img15.png') ,
        } ,
        twoPiece : {
          name : '2片式浮动蝶套件' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/title_text.png') ,
          src1 :    require('@/assets/image/variousproducts/brakediscDetail/2P.png') ,
          src2 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img2.png') ,
          src3 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img3.png') ,
          src4 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img4.png') ,
          src5 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img5.png') ,
          src6 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img6.png') ,
          src7 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img7.png') ,
          src8 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img8.png') ,
          src9 :    require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img9.png') ,
          src10 :   require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img10.png') ,
          src11 :   require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img11.png') ,
          src12 :   require('@/assets/image/variousproducts/brakediscDetail/2片式浮动蝶套件/img12.png') ,
        } ,
        PD : {
          name : 'PD型' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/PD/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/PD/title_text.png') ,
          src1 :    require('@/assets/image/variousproducts/brakediscDetail/PD.png') ,
          src2 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img2.png') ,
          src3 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img3.png') ,
          src4 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img4.png') ,
          src5 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img5.png') ,
          src6 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img6.png') ,
          src7 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img7.png') ,
          src8 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img8.png') ,
          src9 :    require('@/assets/image/variousproducts/brakediscDetail/PD/img9.png') ,
          src10 :   require('@/assets/image/variousproducts/brakediscDetail/PD/img10.png') ,
          src11 :   require('@/assets/image/variousproducts/brakediscDetail/PD/img11.png') ,
          src12 :   require('@/assets/image/variousproducts/brakediscDetail/PD/img12.png') ,
        } ,
        FC : {
          name : 'FC型' ,
          title :  require('@/assets/image/variousproducts/brakediscDetail/FC/title.png') ,
          title_text :  require('@/assets/image/variousproducts/brakediscDetail/FC/title_text.png') ,
          src1 :  require('@/assets/image/variousproducts/brakediscDetail/FC.png') ,
          src2 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img2.png') ,
          src3 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img3.png') ,
          src4 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img4.png') ,
          src5 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img5.png') ,
          src6 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img6.png') ,
          src7 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img7.png') ,
          src8 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img8.png') ,
          src9 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img9.png') ,
          src10 :  require('@/assets/image/variousproducts/brakediscDetail/FC/img10.png') ,

        },

      },
      curData : {}
    }
  },
  methods: {
    getData () {
      let id = this.id
      this.curData = this.pageData[ id ]
    }
  } ,
  created(){
    this.id =  this.$route.params.id  
    this.getData()
  },
  computed: {
    title_object: function () {
      return {
        "t_FP_FS" : this.id == 'FP_FS' ,
        "t_HD_HS" : this.id == 'HD_HS' || this.id == 'HS' ,
        "t_SD" : this.id == 'SD' ,
        't_twoPiece' : this.id == 'twoPiece' ,
        't_PD' : this.id == 'PD' ,
        't_FC' : this.id == 'FC'

      }
    },
    title_name_object : function () {
      return {
        't_n_FP_FS' : this.id == 'FP_FS' ,
        't_n_HD_HS' : this.id == 'HD_HS' || this.id == 'HS' ,
        't_n_SD' : this.id == 'SD' ,
        't_n_twoPiece' : this.id == 'twoPiece' ,
        't_n_PD' : this.id == 'PD' ,
        't_n_FC' : this.id == 'FC'

      }
    },
  },
  watch: {
    $route(to) {
      // 对路由变化作出响应...
      // console.log( to.params.id )
      this.id = to.params.id 
      this.getData()

      // console.log( from )
    }
  }
}
</script>

<style lang="stylus" scoped>
/* 详情页主容器：整体页面宽度与内边距 */
.cont {
  width: 1003px;                 /* 内容总宽度 */
  background-color: #fff;       /* 白色背景 */
  margin: 0 auto;               /* 水平居中 */
  padding: 62px 73px;           /* 内边距：上62 左右73 下62 */
  box-sizing: border-box;       /* 宽高包含 padding */
  position relative             /* 相对定位，供绝对定位的子元素(.title)参照 */
}

/* 清除浮动（clearfix） */
.clear:after { 
  display: block;               /* 伪元素占位 */
  clear: both;                  /* 清除左右浮动，撑起父容器高度 */
  content: '';                  /* 必须的占位内容 */
}

/* 标题框：各型号标题背景图（内联 style 绑定 curData.title）+ 文字图(.title_name) */
.title {
  position: absolute;           /* 绝对定位，相对 .cont 定位 */
  width: 170px;                 /* 标题框宽度 */
  height: 108px;                /* 标题框高度 */
  left: 66px;                   /* 距 .cont 左侧 66px */
  top: -68px;                   /* 向上偏移，盖在容器外上方的凹槽位置 */
  background-repeat: no-repeat; /* 背景图不重复 */
  background-size: cover;       /* 背景图铺满整个标题框 */
  padding: 41px 42px 39px 42px; /* 默认内边距，被各型号 .t_xx 覆盖 */
  box-sizing: border-box;       /* 宽高包含 padding */
  font-size:30px                /* 默认字号（文字图方案时用不到） */
  color:#fff;                   /* 文字白色 */
  text-align :center            /* 文字居中 */
}
/* 以下 .t_xx 为各型号标题框的内边距微调，使文字图在标题框内居中 */
/* 对应 gotoDetail('FP_FS') 的 FP/FS 型 */
.t_FP_FS{
  padding: 28px 41px 16px 49px; /* 上右下左，居中文字图 */
  width: 170px;
  height: 108px;
}
/* 对应 gotoDetail('HD_HS'/'HS') 的 HD/HS 型 */
.t_HD_HS{
  padding: 26px 29px 18px 42px; /* 上右下左，居中文字图 */
  width: 170px;
  height: 108px;
}
/* 对应 gotoDetail('SD') 的 SD 型 */
.t_SD {
    padding: 40px 46px;        /* 上下 左右，居中文字图 */
  width: 170px;
  height: 108px;
}
/* 对应 gotoDetail('twoPiece') 的 2片式浮动蝶套件 */
.t_twoPiece{
  padding: 30px 38px 30px 29px; /* 剩余内容区 103x48，与 .t_n_twoPiece 匹配 */
  width: 170px;
  height: 108px;
}
/* 对应 gotoDetail('PD') 的 PD 型 */
.t_PD{
  padding: 40px 45px 40px 47px; /* 上右下左，居中文字图 */
  width: 170px;
  height: 108px;
}
/* 对应 gotoDetail('FC') 的 FC 型 */
.t_FC {
  padding: 40px 45px 40px 47px; /* 上右下左，居中文字图 */
  width: 170px;
  height: 108px;
}


/* 标题文字图：各型号的设计师切图（内联 style 绑定 curData.title_text） */
.title_name {
  background-repeat: no-repeat; /* 背景图不重复 */
  background-size: contain;     /* 按原始比例完整缩放显示 */
}
/* 以下 .t_n_xx 为各型号文字图的具体显示尺寸 */
/* FP/FS 型文字图尺寸 */
.t_n_FP_FS{
  width: 80px;
  height: 64px;
}
/* HD/HS 型文字图尺寸 */
.t_n_HD_HS{
  width: 99px;
  height: 64px;
}
/* SD 型文字图尺寸 */
.t_n_SD{
  width: 78px;
  height: 28px;
}
/* 2片式浮动蝶套件 文字图尺寸（与 .t_twoPiece 内容区 103x48 匹配） */
.t_n_twoPiece {
  width: 103px;
  height: 48px;
}
/* PD 型文字图尺寸 */
.t_n_PD{
  width: 78px;
  height: 28px;
}
/* FC 型文字图尺寸 */
.t_n_FC{
  width: 78px;
  height: 28px;
}

/* ===== 以下为正文内容排版（当前模板暂未使用，预留） ===== */

/* 大标题文本块 */
.text1{
  width : 296px ;               /* 宽度 */
  font-size : 24px ;            /* 大字号 */
  float: left;                  /* 左浮动 */
  margin-bottom :27px           /* 下间距 */
}
/* 正文文本块 */
.text2{
  width: 411px;                 /* 宽度 */
  font-size :16px               /* 正文字号 */
  float: left;                  /* 左浮动 */
}
/* 红色提示文本块 */
.text3{
  width: 100%;                  /* 占满整行 */
  font-size :16px;              /* 字号 */
  float: left;                  /* 左浮动 */
  color #f90000;                /* 红色文字 */
  margin-top:40px               /* 上间距 */
}
/* 大图容器块 */
.text6{
  width: 596px;                 /* 宽度 */
  height: 554px;                /* 高度 */
  float: left;                  /* 左浮动 */
  margin-top:52px;              /* 上间距 */
  text-align center             /* 内容居中 */
}
/* 整行内容容器块 */
.text7{
  width:100% ;                  /* 占满整行 */
  float: left;                  /* 左浮动 */
  margin-top:40px;              /* 上间距 */
}

</style>